import { useApp } from "@/context/AppContext";
import { Leaf, Heart, Users } from "lucide-react";

const About = () => {
  const { t, lang } = useApp();
  return (
    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-20" data-testid="about-page">
      <div className="max-w-3xl mb-16 animate-fade-up">
        <p className="text-xs uppercase tracking-[0.25em] text-[#C95B24] font-semibold mb-3">{t("about")}</p>
        <h1 className="font-serif-display text-5xl sm:text-6xl text-[#1B4332] mb-6 leading-[1.05]">
          {t("aboutHeading")}
        </h1>
        <p className="text-lg text-[#4A4A4A] leading-relaxed">{t("aboutBody")}</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-16">
        <div className="card-tactile p-10 animate-fade-up delay-1">
          <Heart className="w-8 h-8 text-[#C95B24] mb-4" />
          <h3 className="font-serif-display text-3xl text-[#1B4332] mb-3">{t("ourVision")}</h3>
          <p className="text-[#4A4A4A] leading-relaxed">{t("ourVisionBody")}</p>
        </div>
        <div className="card-tactile p-10 animate-fade-up delay-2">
          <Leaf className="w-8 h-8 text-[#C95B24] mb-4" />
          <h3 className="font-serif-display text-3xl text-[#1B4332] mb-3">{t("ourMission")}</h3>
          <p className="text-[#4A4A4A] leading-relaxed">{t("ourMissionBody")}</p>
        </div>
      </div>

      <div className="rounded-3xl bg-[#F4EFE6] p-10 md:p-16 relative overflow-hidden">
        <div className="max-w-3xl">
          <Users className="w-10 h-10 text-[#1B4332] mb-4" />
          <h3 className="font-serif-display text-3xl text-[#1B4332] mb-4">
            {lang === "hi" ? "हमारे मूल्य" : "Our Values"}
          </h3>
          <ul className="space-y-3 text-[#4A4A4A] text-lg">
            <li>• {lang === "hi" ? "पारदर्शिता — हर रुपये का हिसाब" : "Transparency — every rupee accounted for"}</li>
            <li>• {lang === "hi" ? "करुणा — बिना भेद-भाव के सेवा" : "Compassion — service without distinction"}</li>
            <li>• {lang === "hi" ? "समुदाय — स्थानीय भागीदारी में विश्वास" : "Community — rooted in local participation"}</li>
            <li>• {lang === "hi" ? "स्थायित्व — दीर्घकालिक प्रभाव" : "Sustainability — long-term impact"}</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default About;
